var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import TooltipBootstrap from "react-bootstrap/Tooltip";
import { styleBlock } from "../styleBlock";
const Tooltip = (_a) => {
    var { id, className, placement, tooltip, children, wrap } = _a, rest = __rest(_a, ["id", "className", "placement", "tooltip", "children", "wrap"]);
    const classNames = styleBlock("tooltip");
    const cn = classNames("").mix([className]);
    return (React.createElement(OverlayTrigger, Object.assign({ placement: placement, popperConfig: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 10],
                    },
                },
            ],
        }, overlay: React.createElement(TooltipBootstrap, { id: id, className: cn }, tooltip) }, rest), wrap ? React.createElement("span", { style: { display: "block" } }, children) : children));
};
Tooltip.defaultProps = {
    placement: "auto",
};
export default Tooltip;
//# sourceMappingURL=index.js.map